<script type="text/ecmascript-6">
    import DesignerQuestionCollectionOption from "./DesignerQuestionCollectionOption.vue";
    export default {
        mixins: [
            DesignerQuestionCollectionOption,
        ],
        props: {
            title: {
                required: true,
            },
            component_id: {
                required: true,
            },
            question: {
                required: true,
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/priceable-collection?question=' + this.question;
            },
        },
    }
</script>
